import type { SidebarLink } from '~/types/components/sidebar.types';
import { canViewAuthSidebarExternalLink } from 'r3ui-lib';

export type BuildSidebarLinksParams = {
  path: string;
  t: (key: string) => string;
  hasPermission: (permission: string) => boolean;
  authLink?: string;
  handbookLink?: string;
  createUniqueKey: () => number;
};

function hasActiveChild(links: SidebarLink[]): boolean {
  const children = links[0]?.childrens;
  if (!children?.length) return false;
  return Boolean(children.find(item => item.isActive)?.isActive);
}

/**
 * Строит дерево ссылок сайдбара (без Vue-реактивности).
 */
export function buildSidebarLinks({
  path,
  t,
  hasPermission,
  authLink,
  handbookLink,
  createUniqueKey,
}: BuildSidebarLinksParams): SidebarLink[] {
  const mainLinks: SidebarLink[] = [
    {
      level: 0,
      uniqueKey: createUniqueKey(),
      isVisible: true,
      icon: `<i class="bi bi-file-earmark-text-fill"></i>`,
      label: t('routes.registry'),
      isActive: false,
      childrens: [
        {
          level: 1,
          isVisible: true,
          href: '/map',
          icon: ``,
          label: t('routes.map'),
          isActive: path.includes('/map'),
        },
        {
          level: 1,
          isVisible: true,
          href: '/owners',
          icon: ``,
          label: t('sidebar.owners'),
          isActive: path.includes('/owners'),
        },
        {
          level: 1,
          isVisible: true,
          href: '/objects',
          icon: ``,
          label: t('sidebar.objects'),
          isActive: path.includes('/objects'),
        },
        {
          level: 1,
          isVisible: true,
          href: '/animals',
          icon: ``,
          label: t('sidebar.animals'),
          isActive: path.includes('/animals'),
        },
        {
          level: 1,
          isVisible: true,
          href: '/events',
          icon: ``,
          label: t('sidebar.events'),
          isActive: path.includes('/events'),
        },
      ],
    },
    {
      level: 0,
      isVisible: hasPermission('view-normative-documents'),
      icon: `<i class="bi bi-clipboard-check-fill"></i>`,
      label: t('normative-rules'),
      isActive: path.includes('/rules'),
      childrens: [
        {
          level: 1,
          isVisible: true,
          href: '/rules/pets-import',
          icon: '',
          label: t('routes.rules-pets-import'),
          isActive: path.includes('/pets-import'),
        },
      ],
    },
  ];

  mainLinks[0]!.isActive = hasActiveChild(mainLinks);

  return [
    {
      level: 0,
      uniqueKey: createUniqueKey(),
      isVisible: canViewAuthSidebarExternalLink(hasPermission),
      href: authLink,
      icon: `<i class="bi bi-person-square"></i>`,
      label: t('auth.Authorization'),
      isActive: false,
      isExternal: true,
      openInNewWindow: false,
    },
    ...mainLinks,
    {
      level: 0,
      uniqueKey: createUniqueKey(),
      isVisible: hasPermission('sidebar-view-handbook'),
      href: handbookLink,
      icon: `<i class="bi bi-book-fill"></i>`,
      label: t('routes.handbook'),
      isActive: false,
      isExternal: true,
      openInNewWindow: false,
    },
  ];
}
